import * as React from "react";
export var _MasterDetailView = function (_a) {
    var Master = _a.masterRenderer, Detail = _a.detailRenderer;
    var _b = React.useState(undefined), currentItem = _b[0], setCurrentItem = _b[1];
    return (React.createElement("div", { className: "master-detail-view" },
        React.createElement("div", { className: "master-detail-view__master-view" },
            React.createElement(Master, { onSelect: function (item) { return setCurrentItem(item); } })),
        React.createElement("div", { className: "master-detail-view__detail-view" },
            React.createElement(Detail, { item: currentItem }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/master-detail-view/MasterDetailView.tsx
// module id = 199
// module chunks = 3